import React, { useState, useEffect } from 'react';
import { Search, Plus, Edit2, Shield, Trash2, CheckCircle2, XCircle, X, AlertCircle, Lock as LockIcon,FileSpreadsheet } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import api from '../../api/axios'; 
import { useAuth } from '../../context/AuthContext';

export const PERMISSIONS_LIST = [
    { id: 'envios_view', name: 'Página Envíos' },
    { id: 'choferes_view', name: 'Página Choferes' },
    { id: 'rutas_view', name: 'Página Rutas' },
    { id: 'usuarios_view', name: 'Página Usuarios' },
    { id: 'reseñas_view', name: 'Página Reseñas' },
    { id: 'vacantes_view', name: 'Página Vacantes' }
];

const UsuariosPage = () => {
  console.log("UsuariosPage: Iniciando renderizado...");
  const [debugError, setDebugError] = React.useState(null);
  // Busca donde tienes tus estados y asegúrate de tener este:
  const [newRoleName, setNewRoleName] = useState('');
const [selectedPages, setSelectedPages] = useState([]);
const [selectedUser, setSelectedUser] = useState(null);
  const { user: currentUser } = useAuth(); 

  const [searchTerm, setSearchTerm] = useState('');
  const [usuarios, setUsuarios] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    id: null, name: '', email: '',phone:'', password: '',password_confirmation: '', role: '', status: 'Activo'
  });
  const [isRoleModalOpen, setIsRoleModalOpen] = useState(false);
  const [roles, setRoles] = useState([]);

  // 1. OBTENER USUARIOS (Con extracción inteligente de datos)
  const fetchUsuarios = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await api.get('/users');
      // Manejamos si Laravel envía los datos directos o envueltos en .data
      const dataObtenida = response.data.data || response.data;
      setUsuarios(Array.isArray(dataObtenida) ? dataObtenida : []);
    } catch (err) {
      console.error("Error al sincronizar usuarios:", err);
      setError("No se pudo conectar con el servidor. Revisa tu conexión.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsuarios();
  }, []);

  // 2. ELIMINAR USUARIO (Jerarquía de Seguridad)
  const handleDelete = async (userToDelete) => {
    // Regla: No borrarse a sí mismo
    if (userToDelete.id === currentUser?.id) {
      alert("Operación denegada: No puedes eliminar tu propia cuenta.");
      return;
    }
    // Regla: Administradores no borran al Maestro
    if (currentUser?.role === 'Administrador' && userToDelete.role === 'Maestro') {
      alert("Seguridad TBT: No tienes permisos para eliminar la cuenta Maestro.");
      return;
    }

    if (!window.confirm(`¿Estás seguro de eliminar a ${userToDelete.name}?`)) return;
    
    try {
      await api.delete(`/users/${userToDelete.id}`);
      setUsuarios(usuarios.filter(u => u.id !== userToDelete.id));
    } catch (err) {
      alert("Hubo un error al intentar eliminar el registro.");
    }
  };

  // 3. GESTIÓN DEL MODAL
const openModal = (user = null) => {
    setSelectedUser(user);
    setError(null);
    if (user) {
        setIsEditing(true);
        setFormData({ 
            id: user.id, 
            name: user.name, 
            email: user.email, 
            phone: user.phone || '', 
            password: '', 
            role: user.role || '', // <--- Esto ya está bien
            status: user.status || 'Activo' 
        });
    } else {
        setIsEditing(false);
        setFormData({ 
            id: null, name: '', email: '', phone: '', password: '', password_confirmation: '', role: '', status: 'Activo' 
        });
    }
    setIsModalOpen(true);
};
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      if (isEditing) {
        const response = await api.put(`/users/${formData.id}`, formData);
        const updated = response.data.user || response.data.data || response.data;
        setUsuarios(usuarios.map(u => (u.id === formData.id ? updated : u)));
      } else {
        const response = await api.post('/users', formData);
        const created = response.data.user || response.data.data || response.data;
        setUsuarios([...usuarios, created]);
      }
      setIsModalOpen(false);
    } catch (err) {
      setError(err.response?.data?.message || "Error al procesar la solicitud.");
    } finally {
      setIsLoading(false);
    }
  };
  // REGLA DE ORO: Bloqueo de rol para Maestro y Admin propio
const isRoleDisabled = !!isEditing && (
  formData.role === 'Maestro' || 
  selectedUser?.role === 'Cliente' || 
  (currentUser?.role === 'Administrador' && Number(formData.id) === Number(currentUser?.id))
);
  const handleToggleStatus = async (user) => {
  const nuevoStatus = user.status === 'Activo' ? 'Inactivo' : 'Activo';
  // Aquí haces tu petición api.put(`/users/${user.id}`, { status: nuevoStatus })
  // Y luego actualizas el estado local de 'usuarios'
};
const handleConfirmChanges = async () => {
  setLoading(true);
  
  // 1. Clonamos los datos del formulario para no afectar la UI
  const dataToSend = { ...formData };

  // 2. Si la contraseña está vacía o son puros espacios, la eliminamos
  if (!dataToSend.password || dataToSend.password.trim() === "") {
    delete dataToSend.password;
  }

  try {
    // 3. Enviamos solo lo que tiene contenido real
    const response = await api.put(`/users/${selectedUser.id}`, dataToSend);
    
    if (response.status === 200) {
      // Actualizamos la lista local, cerramos modal, etc.
      setUsuarios(usuarios.map(u => u.id === selectedUser.id ? response.data.data : u));
      closeModal();
      alert("Usuario actualizado con éxito");
    }
  } catch (err) {
    console.error("Error al actualizar:", err);
    // Aquí puedes manejar el error visualmente
  } finally {
    setLoading(false);
  }
};
const handleExportUsers = async () => {
    try {
        const response = await api.get('/export/users-all', {
            responseType: 'blob' 
        });

        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv;charset=utf-8;' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Reporte_Usuarios_GrupoTBT.csv');
        document.body.appendChild(link);
        link.click();
        
        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error al exportar:", error);
        alert("❌ No se pudo generar el reporte.");
    }
};

// 1. Cargar los roles al iniciar
useEffect(() => {
    const fetchRoles = async () => {
        try {
            const response = await api.get('/roles');
            setRoles(response.data);
        } catch (error) {
            console.error("Error al cargar roles:", error);
        }
    };
    fetchRoles();
}, []);

const handleSaveRole = async () => {
    if (!newRoleName.trim()) {
        alert("El nombre del rol es obligatorio");
        return;
    }

    try {
        // ENVIAMOS EL ARRAY DE PERMISOS
        const response = await api.post('/roles', { 
            name: newRoleName,
            permissions: selectedPages // <--- Aquí pasamos los IDs seleccionados
        });
        
        setRoles([...roles, response.data]); 
        setNewRoleName('');
        setSelectedPages([]); // Limpiamos selección
        alert("Rol y permisos creados exitosamente");
        setIsRoleModalOpen(false); 
    } catch (error) {
        console.error("Error al guardar:", error.response?.data); 
        alert("No se pudo crear el rol.");
    }
};



const handleDeleteRole = async (roleId) => {
    if (!window.confirm("¿Estás seguro de eliminar este rol? Esta acción no se puede deshacer.")) return;

    try {
        await api.delete(`/roles/${roleId}`);
        // Actualizamos la lista local filtrando el rol eliminado
        setRoles(roles.filter(r => r.id !== roleId));
        alert("Rol eliminado correctamente");
    } catch (error) {
        console.error("Error al eliminar rol:", error);
        alert("No se pudo eliminar el rol. Verifica que no haya usuarios asignados a él.");
    }
};
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="space-y-6">
      
      {/* HEADER CORPORATIVO */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h2 className="text-2xl font-black text-gray-900 dark:text-white uppercase tracking-tighter">Directorio de Usuarios</h2>
          <p className="text-sm text-gray-500 dark:text-white/60 font-medium italic">Gestión de identidades y accesos - Grupo TBT</p>
        </div>
        {/* DIV CONTENEDOR: Aquí agrupamos ambos botones */}
  <div className="flex items-center gap-2">
    <button 
      onClick={handleExportUsers}
      className="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-xl font-bold transition-all shadow-lg hover:shadow-xl active:scale-95"
    >
      <FileSpreadsheet size={18} /> Exportar Excel
    </button>

    <button 
      onClick={() => openModal()} 
      className="flex items-center gap-2 bg-[#CE010B] hover:bg-red-800 text-white px-6 py-3 rounded-xl font-bold transition-all shadow-lg hover:shadow-xl active:scale-95"
    >
      <Plus size={20} /> Registrar Usuario
    </button>
    <button 
        onClick={() => setIsRoleModalOpen(true)}
        className="flex items-center gap-2 bg-neutral-800 text-white px-4 py-3 rounded-xl font-bold"
    >
        <Shield size={18} /> Gestionar Roles
    </button>
  </div>
      </div>

      {/* BARRA DE FILTRO */}
      <div className="bg-white/80 dark:bg-black/20 backdrop-blur-md p-4 rounded-2xl border border-black/5 dark:border-white/10 shadow-sm">
        <div className="relative w-full sm:w-96">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
          <input type="text" placeholder="Filtrar por nombre o email..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-12 pr-4 py-3 rounded-xl bg-gray-100 dark:bg-black/40 border-none text-gray-800 dark:text-white focus:ring-2 focus:ring-[#CE010B] outline-none transition-all" />
        </div>
      </div>

      {/* TABLA DE GESTIÓN */}
      <div className="bg-white dark:bg-black/20 rounded-2xl border border-black/5 dark:border-white/10 shadow-sm overflow-hidden min-h-[300px]">
        {isLoading && usuarios.length === 0 ? (
          <div className="flex flex-col items-center justify-center p-20 gap-4">
            <div className="w-10 h-10 border-4 border-[#CE010B] border-t-transparent rounded-full animate-spin"></div>
            <p className="text-xs font-black text-gray-400 uppercase tracking-widest">Sincronizando Base de Datos...</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-gray-50 dark:bg-white/5 border-b border-black/5 dark:border-white/10">
                  <th className="py-4 px-6 text-[10px] uppercase font-black text-gray-400 tracking-widest">Colaborador</th>
                  <th className="py-4 px-6 text-[10px] uppercase font-black text-gray-400 tracking-widest">Nivel / Rol</th>
                  <th className="py-4 px-6 text-[10px] uppercase font-black text-gray-400 tracking-widest">Estatus</th>
                  <th className="py-4 px-6 text-[10px] uppercase font-black text-gray-400 tracking-widest text-right">Acciones</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-black/5 dark:divide-white/10">
  {usuarios
    .filter(u => u.name?.toLowerCase().includes(searchTerm.toLowerCase()))
    .map((user) => {
      
      // 1. Validamos que tengamos al usuario actual antes de comparar
      const currentUserId = currentUser?.id;
      const currentUserRole = currentUser?.role;

      // 2. Definimos las reglas de seguridad
      const isSelf = user.id === currentUserId;
      const isAdminTargetingMaestro = currentUserRole === 'Administrador' && user.role === 'Maestro';
      
      // 3. ¿Puede borrar o cambiar estatus?
      const canDelete = !isSelf && !isAdminTargetingMaestro;
      const canChangeStatus = !isSelf && !isAdminTargetingMaestro;

      return (
        <tr key={user.id} className="hover:bg-gray-50 dark:hover:bg-white/5 transition-colors group">
          <td className="py-4 px-6">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-full bg-gray-100 dark:bg-white/10 flex items-center justify-center text-gray-600 dark:text-white font-bold shadow-inner uppercase">
                {user.name?.charAt(0) || '?'}
              </div>
              <div>
                <p className="font-bold text-gray-900 dark:text-white flex items-center gap-2">
                  {user.name}
                  {isSelf && (
                    <span className="text-[9px] bg-blue-100 text-blue-600 px-1.5 py-0.5 rounded uppercase font-black tracking-tighter">
                      Tú
                    </span>
                  )}
                </p>
                <p className="text-xs text-gray-400">{user.email}</p>
              </div>
            </div>
          </td>
          
          <td className="py-4 px-6">
            <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-black border uppercase tracking-tighter ${
              user.role === 'Maestro' ? 'bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-500/20 dark:text-amber-400' :
              user.role === 'Administrador' ? 'bg-purple-100 text-purple-700 border-purple-200 dark:bg-purple-500/20 dark:text-purple-400' :
              user.role === 'Operador' ? 'bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-500/20 dark:text-blue-400' :
              'bg-gray-100 text-gray-500 border-gray-200 dark:bg-white/5 dark:text-white/40' 
            }`}>
              {user.role === 'Maestro' && <Shield size={10} />} {user.role || 'Cliente'}
            </span>
          </td>

          <td className="py-4 px-6">
            <div className="flex items-center gap-2">
              <div className={`w-2 h-2 rounded-full ${user.status === 'Activo' ? 'bg-emerald-500' : 'bg-red-500'}`}></div>
              <span className={`text-xs font-bold ${user.status === 'Activo' ? 'text-emerald-600' : 'text-red-600'}`}>
                {user.status}
              </span>
              {/* Si no puede cambiar status, mostramos candado pero NO rompemos el diseño */}
              {!canChangeStatus && <LockIcon size={10} className="text-gray-300 ml-1" />}
            </div>
          </td>

          <td className="py-4 px-6 text-right">
            <div className="flex items-center justify-end gap-2">
              <button onClick={() => openModal(user)} className="p-2.5 rounded-lg bg-gray-100 dark:bg-white/10 text-gray-400 hover:text-[#CE010B] transition-all">
                <Edit2 size={16} />
              </button>

              <button 
                onClick={() => canDelete ? handleDelete(user) : null} 
                className={`p-2.5 rounded-lg transition-all ${
                  canDelete 
                    ? 'bg-gray-100 dark:bg-white/10 text-gray-400 hover:text-red-600' 
                    : 'opacity-20 cursor-not-allowed'
                }`}
              >
                <Trash2 size={16} />
              </button>
            </div>
          </td>
        </tr>
      );
    })}
</tbody>
            </table>
          </div>
        )}
      </div>

      {/* MODAL BLINDADO */}
      <AnimatePresence>
        {isModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
            <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }}
              className="bg-white dark:bg-neutral-900 rounded-3xl w-full max-w-lg shadow-2xl overflow-hidden border border-black/10 dark:border-white/10"
            >
              <div className="p-6 border-b border-black/5 dark:border-white/10 flex justify-between items-center bg-gray-50/50 dark:bg-white/5">
                <h3 className="text-xl font-black text-gray-900 dark:text-white uppercase tracking-tighter">
                  {isEditing ? 'Configuración de Usuario' : 'Alta de Nuevo Usuario'}
                </h3>
                <button onClick={() => setIsModalOpen(false)} className="text-gray-400 hover:text-red-500 p-2"><X size={24} /></button>
              </div>

              <form onSubmit={handleSubmit} className="p-8 space-y-5">
                {error && (
                  <div className="flex items-center gap-2 bg-red-100 text-red-700 p-4 rounded-2xl text-sm font-bold border border-red-200">
                    <AlertCircle size={18} /> {error}
                  </div>
                )}

                <div className="space-y-4">
                  <div>
                    <label className="block text-[10px] font-black text-gray-400 uppercase mb-1 tracking-widest">Nombre Completo</label>
                    <input type="text" required value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})}
                      className="w-full px-4 py-3 rounded-xl bg-gray-100 dark:bg-black/40 border border-transparent focus:border-[#CE010B] focus:bg-white dark:focus:bg-black dark:text-white outline-none transition-all" />
                  </div>
                  <div>
                    <label className="block text-[10px] font-black text-gray-400 uppercase mb-1 tracking-widest">Email Corporativo / Cliente</label>
                    <input type="email" required value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})}
                      className="w-full px-4 py-3 rounded-xl bg-gray-100 dark:bg-black/40 border border-transparent focus:border-[#CE010B] focus:bg-white dark:focus:bg-black dark:text-white outline-none transition-all" />
                  </div>
                  <div>
                      <label className="block text-[10px] font-black text-gray-400 uppercase mb-1 tracking-widest">
                          Teléfono de Contacto (10 dígitos)
                      </label>
                      <input 
                          type="tel" 
                          placeholder="Ej. 5512345678"
                          value={formData.phone} 
                          onChange={e => setFormData({
                              ...formData, 
                              phone: e.target.value.replace(/\D/g, '').slice(0, 10) // Validación instantánea
                          })}
                          className="w-full px-4 py-3 rounded-xl bg-gray-100 dark:bg-black/40 border border-transparent focus:border-[#CE010B] focus:bg-white dark:focus:bg-black dark:text-white outline-none transition-all" 
                      />
                  </div>
                  <div>
                    <label className="block text-[10px] font-black text-gray-400 uppercase mb-1 tracking-widest">Password {isEditing && '(Opcional)'}</label>
                    <input type="password" required={!isEditing} value={formData.password} onChange={e => setFormData({...formData, password: e.target.value})}
                      className="w-full px-4 py-3 rounded-xl bg-gray-100 dark:bg-black/40 border border-transparent focus:border-[#CE010B] focus:bg-white dark:focus:bg-black dark:text-white outline-none transition-all" />
                  </div>
                  <div>
                      <label className="block text-[10px] font-black text-gray-400 uppercase mb-1 tracking-widest">
                          Confirmar Password
                      </label>
                      <input 
                          type="password" 
                          required={!isEditing} 
                          value={formData.password_confirmation} 
                          onChange={e => setFormData({...formData, password_confirmation: e.target.value})}
                          className="w-full px-4 py-3 rounded-xl bg-gray-100 dark:bg-black/40 border border-transparent focus:border-[#CE010B] focus:bg-white dark:focus:bg-black dark:text-white outline-none transition-all" 
                      />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                      <label className="block text-[10px] font-black text-gray-400 uppercase mb-1 tracking-widest">Rango de Sistema</label>
                      <select 
                          required
                          value={formData.role} 
                          onChange={e => setFormData({...formData, role: e.target.value})}
                          disabled={isRoleDisabled}
                          className={`w-full px-4 py-3 rounded-xl border-none outline-none transition-all font-bold ${
                              isRoleDisabled 
                              ? 'bg-gray-200 dark:bg-white/5 text-gray-400 cursor-not-allowed' 
                              : 'bg-gray-100 dark:bg-black/40 dark:text-white focus:bg-white dark:focus:bg-black ring-1 ring-transparent focus:ring-[#CE010B]'
                          }`}
                      >
                          <option value="">Selecciona un rol</option>
                          {roles.map((r) => (
                              <option key={r.id} value={r.name}>
                                  {r.name}
                              </option>
                          ))}
                      </select>
                      {isRoleDisabled && <p className="text-[9px] mt-1 text-amber-600 font-bold uppercase italic">Protegido por Sistema</p>}
                  </div>
                  <div>
                    <label className="block text-[10px] font-black text-gray-400 uppercase mb-1 tracking-widest">Estatus de Cuenta</label>
                    <select value={formData.status} onChange={e => setFormData({...formData, status: e.target.value})}
                      className="w-full px-4 py-3 rounded-xl bg-gray-100 dark:bg-black/40 dark:text-white border-none outline-none focus:bg-white dark:focus:bg-black transition-all">
                      <option value="Activo">Activo</option>
                      <option value="Inactivo">Inactivo</option>
                    </select>
                  </div>
                </div>

                <div className="pt-6 border-t border-black/5 dark:border-white/10 flex justify-end gap-4">
                  <button type="button" onClick={() => setIsModalOpen(false)} className="px-6 py-3 rounded-xl font-bold text-gray-400 hover:text-gray-600 dark:hover:text-white transition-colors">Cancelar</button>
                  <button type="submit" disabled={isLoading} className="px-8 py-3 rounded-xl font-black text-white bg-[#CE010B] hover:bg-red-700 shadow-xl shadow-red-500/20 active:scale-95 disabled:opacity-50 transition-all">
                    {isLoading ? '...' : 'Confirmar Cambios'}
                  </button>
                </div>
              </form>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
{/* MODAL DE GESTIÓN DE ROLES */}
<AnimatePresence>
  {isRoleModalOpen && (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <motion.div 
        initial={{ scale: 0.95, opacity: 0 }} 
        animate={{ scale: 1, opacity: 1 }} 
        exit={{ scale: 0.95, opacity: 0 }}
        className="bg-white dark:bg-neutral-900 rounded-3xl w-full max-w-md shadow-2xl p-8 border border-black/10 dark:border-white/10"
      >
        <h3 className="text-xl font-black text-gray-900 uppercase mb-4">Gestionar Roles</h3>
        
        <div className="space-y-4">
          <input 
            type="text" 
            placeholder="Nombre del nuevo rol" 
            value={newRoleName} 
            onChange={(e) => setNewRoleName(e.target.value)}
            className="w-full px-4 py-3 rounded-xl bg-gray-100 dark:bg-black/40 border-none outline-none dark:text-white"
          />

          <div>
            <p className="text-xs font-bold text-gray-400 uppercase mb-2">Permisos del Rol:</p>
            <div className="max-h-40 overflow-y-auto space-y-2 border border-black/10 dark:border-white/10 p-3 rounded-xl">
              {/* Aquí usamos el PERMISSIONS_LIST que está definido fuera */}
              {PERMISSIONS_LIST.map(p => (
                <label key={p.id} className="flex items-center gap-2 cursor-pointer text-sm dark:text-gray-300">
                  <input 
                    type="checkbox" 
                    checked={selectedPages.includes(p.id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedPages([...selectedPages, p.id]);
                      } else {
                        setSelectedPages(selectedPages.filter(id => id !== p.id));
                      }
                    }}
                    className="accent-[#CE010B]"
                  />
                  {p.name}
                </label>
              ))}
            </div>
          </div>
          
          <div className="mt-4">
            <p className="text-xs font-bold text-gray-400 uppercase mb-2">Roles Actuales:</p>
            <div className="max-h-40 overflow-y-auto space-y-2">
              {roles.map(r => (
                <div key={r.id} className="flex justify-between items-center p-3 bg-gray-50 dark:bg-white/5 rounded-lg text-sm dark:text-white">
                  <div>
                    <span className="font-bold">{r.name}</span>
                    <p className="text-[10px] text-gray-400">
                        {(() => {
                            // 1. Si es null, es 0
                            if (!r.permissions) return "0 permisos";
                            
                            // 2. Si ya es array (caso raro pero posible), lo contamos
                            if (Array.isArray(r.permissions)) return `${r.permissions.length} permisos`;
                            
                            // 3. Si es string (el caso que tenemos), lo convertimos
                            try {
                                const parsed = JSON.parse(r.permissions);
                                return `${parsed.length} permisos`;
                            } catch (e) {
                                return "0 permisos";
                            }
                        })()}
                    </p>
                  </div>
                  <button 
                    onClick={() => handleDeleteRole(r.id)}
                    className="text-red-500 hover:text-red-700 p-2"
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-4 mt-6">
          <button 
            onClick={() => setIsRoleModalOpen(false)} 
            className="text-gray-400 font-bold hover:text-gray-600"
          >
            Cancelar
          </button>
          <button 
            onClick={() => {
              handleSaveRole();
              setSelectedPages([]); 
            }} 
            className="bg-[#CE010B] text-white px-6 py-2 rounded-lg font-bold"
          >
            Guardar Rol y Permisos
          </button>
        </div>
      </motion.div>
    </div>
  )}
</AnimatePresence>
    </motion.div>
  );
};

export default UsuariosPage;